import React from 'react'
import PageTitle from '../../components/PageTitle'
import Layout from '../../components/Layout'
import { withPrefix } from 'gatsby'

const PARC = () => (
  <Layout>
    <PageTitle name="Policy Advising Review Committee (PARC)" site="OIRA" />
    <ul>
      <li>
        <a href={withPrefix('/policy-template-use.docx')}>UA Policy Template</a>
      </li>
      <li>
        <a href={withPrefix('/Policy-Tracking-Form.pdf')}>
          UA Policy Tracking Form
        </a>
      </li>
      <li>
        <a href={withPrefix('/Policy-Tracking-Form_Colleges.pdf')}>
          College Policy Tracking Form
        </a>
      </li>
    </ul>
  </Layout>
)

export default PARC
